import axios from 'axios';
import urlTemplate from 'url-template';
import * as moment from 'moment';
import '../Helpers/Namespace';
import config from '../../../Config';
//import cache from '../Helpers/Cache';
//import * as mockFactory from '../Helpers/MockFactory';

async function getToken() {
  const { token, tokenExpires } = window.paylocity.talent.forms;
  const minutesRemaining = moment.duration(moment(tokenExpires).diff(moment())).asMinutes();

  // if user/session is an external/public, use the explicitely-set pctytalentformstoken from the UI
  if (!window.pctygatewaytoken && window.pctytalentformstoken) {
    window.paylocity.talent.forms.token = window.pctytalentformstoken;
    return window.pctytalentformstoken;
  }
  else {
    // Use existing token if available
    if (token && minutesRemaining > 5) {
      return token;
    }
    else {      
      // Otherwise fetch a new one
      let newToken;
      try {
        newToken = await axios.get(getTokenUrl());

        if (newToken && newToken.status === 200) {
          if (newToken.data.token && newToken.data.expiresIn) {
            window.paylocity.talent.forms.token = newToken.data.token;
            window.paylocity.talent.forms.tokenExpires = moment().add(newToken.data.expiresIn, 'ms').toDate();
      
            return newToken.data.token;
          }
          else {
            window.location.reload();
          }
        }
      } 
      catch (error) {
        window.location.reload();
      }
    }
  }
}

function getTokenUrl() {


  if ((window.location.pathname.match(/Escher\/Escher_WebUI/gi) || []).length) {
    return config.gatewayTokenUrl;
  }

  let baseUrl = config.devMode ? config.devAppShellBaseUrl : window.location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1];
  let endpoint = config.gatewayTokenUrl.substring(config.gatewayTokenUrl.indexOf('/GatewayToken'));
  
  return `${baseUrl}${endpoint}`;
}

async function options(gatewayRequest, responseType, isPublic=false) {
  const options = {
    headers: {}
  };

  // Always include auth token
  options.headers['Authorization'] = 'Bearer ' + await getToken();
  options.headers['Cache-Control'] = 'no-cache';
  options.headers['Pragma'] = 'no-cache';
  options.headers['Expires'] = '-1';  

  // Include "forward header" if this is a gateway request
  if (gatewayRequest) {
    if (isPublic) { 
      options.headers['X-Pcty-Forward-To'] = 'Api-Gateway-Ext';
    } else {
      options.headers['X-Pcty-Forward-To'] = 'Api-Gateway';
    }
  }

  // Include response type if specified
  if (responseType) {
    options.responseType = responseType;
  }

  return options;
}

function cleanResult(httpResult) {
  if (httpResult && httpResult.status < 300) {
    return httpResult.data;
  }
  return { error: httpResult.statusText };
}

export async function get(url, params, gatewayRequest = true, responseType, isPublic=false) {
  try {
    /*
    // Check for configured mock data (for development use only).    
    const mockedDataByUrlTemplate = mockFactory.invoke(url, params);
    if (mockedDataByUrlTemplate) {
      return mockedDataByUrlTemplate;
    }

    const mockedDataByParsedUrl = mockFactory.invoke(urlTemplate.parse(url).expand(params), params);

    if (mockedDataByParsedUrl) {
      return mockedDataByParsedUrl;
    }
*/    
    let result = undefined;    
    let fullUrl = urlTemplate.parse(url).expand(params);      
    result = await axios.get(fullUrl, (await options(gatewayRequest, responseType, isPublic)))
                        .then(cleanResult);    

    return result;
  } catch (ex) {
    throw new Error(`${ex.message} (GET: ${urlTemplate.parse(url).expand(params)})`);
  }
}

export async function post(url, params, model, gatewayRequest = true, isPublic=false) {
  try {
    let fullUrl = urlTemplate.parse(url).expand(params);
    return axios.post(fullUrl, model, (await options(gatewayRequest, undefined, isPublic))).then(cleanResult);
  } catch (ex) {
    throw new Error(`${ex.message} (POST: ${urlTemplate.parse(url).expand(params)})`);
  }
}

export async function patch(url, params, model, gatewayRequest = true, isPublic=false) {
  try {
    let fullUrl = urlTemplate.parse(url).expand(params);
    return axios.patch(fullUrl, model, (await options(gatewayRequest, undefined, isPublic))).then(cleanResult);
  } catch (ex) {
    throw new Error(`${ex.message} (PATCH: ${urlTemplate.parse(url).expand(params)})`);
  }
}

export async function remove(url, params, gatewayRequest = true, isPublic=false) {
  try {
    let fullUrl = urlTemplate.parse(url).expand(params);
    return axios.delete(fullUrl, (await options(gatewayRequest, undefined, isPublic))).then(cleanResult);
  } catch (ex) {
    throw new Error(`${ex.message} (DELETE: ${urlTemplate.parse(url).expand(params)})`);
  }
}
